import axios from 'axios';
import { Component } from 'react';
import Constants from '../data/constants';

class CallHandler extends Component {
  constructor(props) {
      super(props);
  }

  async getCountryData() {
    const locale = (typeof window.Tesla !== "undefined") ? window.Tesla.locale : "en_US";
    let additionalData = "";
    if (["zh_CN", "ko_KR"].indexOf(locale) > -1) {
      additionalData = '&additional=true';
    }
    const response = await axios.get('/cua-api/drive/country-data?locale=' + locale + additionalData);
    return response;
  }

  async post(data, getData, findUs) {
    let localData = {
            firstName: null,
            lastName: null,
            email: null,
            phone: null,
            country: null,
            locale_code: null,
            zip: null,
            einterest: null,
            getUpdates: null,
            model: null,
            anumber: null,
            snumber: null,
            campaign: null,
        };

    for (const k in localData) {
        if (data[k] !== "") {
          localData[k] = data[k];
        }
    }

    let path = "regular";
    if (window.location.search.includes('model=')) {
        const models = {
            "ms": Constants().MODEL_S,
            "mx": Constants().MODEL_X,
            "m3": Constants().MODEL_3,
            "my": Constants().MODEL_Y
        }
        path = "model-spec";
        localData.model = models[window.location.search.split('model=')[1]];
    }

    if (typeof data.province !== "undefined") {
        localData.province = data.province;
    }

    if (typeof data.cities !== "undefined") {
        localData.cities = data.cities;
    }

    if (typeof data.localName !== "undefined") {
        localData.localName = data.localName;
    }

    let requestObj = {
        data: localData,
        getData: getData,
        path: path
    };

    if (data.setAppointmentId) {
      for (const k in data) {
        if (data[k] !== "") {
          requestObj.data[k] = data[k];
        }
      }
    }

    const url = findUs ? "generic-submit" : "submit";

  try {
    const response = await axios.post('/cua-api/drive/' + url, requestObj);
    return response.data;
  } catch (error) {
  }
  }

    async uploadFile(elem, file) {
        const formData = new FormData();

        formData.append(
            'file',
            file
        );

        try {
            const response = await axios.post('/cua-api/drive/fileupload', formData);
            response.data.elem = elem;
            return response.data;
        } catch (error) {
        }
    }
}

export default CallHandler;
